'use client'

import { useRouter } from 'next/navigation'
import { useCallback } from 'react'

import { getDiscountOrderUrl } from '@/entities/catalog-discount'

import { DISCOUNT_ORDER_SOURCE } from '@/shared/lib/const/order-source'

import { fetchYaPayId } from '../../api/fetchYaPayId'

import cl from './loadingState.module.scss'

export const useYaPayButtonClick = (orderSource?: string) => {
	const router = useRouter()

	const onClick = useCallback(
		async (node: HTMLElement, idList: number[]) => {
			try {
				node.classList.add(cl.load)

				const { data } = await fetchYaPayId()
				const productId = idList[idList.length - 1]
				const fastOrderLink =
					orderSource === DISCOUNT_ORDER_SOURCE && productId != null
						? `${getDiscountOrderUrl({ ID: productId })}&payment=${data.PAY_ID}`
						: `/order/${idList}?payment=${data.PAY_ID}`

				router.push(fastOrderLink)
			} catch {}
		},
		[orderSource, router]
	)

	return {
		onClick
	}
}
